import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { get } from "../../config/api";
import { errorNotification } from "../../Generic/Notifications";
import { setMachines } from "../../Landing/Actions";

let inFlightPromise = null;

async function loadMachines(dispatch, currentMachines, { force } = {}) {
	if (Array.isArray(currentMachines) && !force) {
		return { ok: true, data: currentMachines };
	}

	if (inFlightPromise && !force) {
		return inFlightPromise;
	}

	const fetchPromise = (async () => {
		const response = await get({ url: "/v1/dashboard/restaurant/all" });
		const { data, error } = response;
		if (data) {
			const list = Array.isArray(data) ? data : [];
			dispatch(setMachines(list));
			return { ok: true, data: list };
		}
		if (error) {
			errorNotification(error);
		}
		return { ok: false, error };
	})();

	inFlightPromise = fetchPromise;
	try {
		return await fetchPromise;
	} finally {
		if (inFlightPromise === fetchPromise) {
			inFlightPromise = null;
		}
	}
}

export default function useMachines() {
	const dispatch = useDispatch();
	const machines = useSelector((state) => state.landing.machines);
	const [loading, setLoading] = useState(!Array.isArray(machines));
	const [error, setError] = useState(null);

	const reload = useCallback(async ({ force } = {}) => {
		setLoading(true);
		setError(null);
		const result = await loadMachines(dispatch, machines, { force });
		if (!result.ok) setError(result.error || true);
		setLoading(false);
		return result;
	}, [dispatch, machines]);

	useEffect(() => {
		if (!Array.isArray(machines)) reload();
	}, [machines, reload]);

	return { machines: machines || [], loaded: Array.isArray(machines), loading, error, reload };
}
